module.exports = __webpack_public_path__ + "static/img/pic01.8e7632c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/study/pic01.png
// module id = 0mLD
// module chunks = 0